import { captureException, captureMessage } from "./error-reporting";

// Internal logging function
const log = (
  message: string,
  severity: "info" | "warning" | "error",
  error?: Error,
  extra?: Record<string, unknown>
) => {
  if (error) {
    captureException(error, {
      level: severity,
      extra: {
        message,
        ...extra
      }
    });
  } else {
    captureMessage(message, {
      level: severity,
      extra
    });
  }

  // Console logging for non-production environments
  if (
    (process.env.NODE_ENV !== "production" || typeof window === "undefined") &&
    process.env.NODE_ENV !== "test"
  ) {
    switch (severity) {
      case "info": {
        console.info(message);
        break;
      }
      case "warning": {
        console.warn(message);
        break;
      }
      case "error": {
        console.error(
          `${message}: \n${!!error && error.stack ? error.stack : ""} `
        );
        break;
      }
      default: {
        console.log(message);
        break;
      }
    }
  }
};

/**
 * Log info level message
 */
export const info = (
  message: string,
  error?: Error,
  extra?: Record<string, unknown>
): void => {
  log(message, "info", error, extra);
};

/**
 * Log warning level message
 */
export const warn = (
  message: string,
  error?: Error,
  extra?: Record<string, unknown>
): void => {
  log(message, "warning", error, extra);
};

/**
 * Log error level message
 */
export const error = (
  message: string,
  error?: Error,
  extra?: Record<string, unknown>
): void => {
  log(message, "error", error, extra);
};

export const logger = {
  info: (
    message: string,
    errorParam?: Error,
    extra?: Record<string, unknown>
  ) => info(message, errorParam, extra),
  warn: (
    message: string,
    errorParam?: Error,
    extra?: Record<string, unknown>
  ) => warn(message, errorParam, extra),
  error: (
    message: string,
    errorParam?: Error,
    extra?: Record<string, unknown>
  ) => error(message, errorParam, extra)
};

export default logger;
